import { Button, Flex, Image, Text } from "@chakra-ui/react"
import { CHAIN_ID } from "@mezo/sdk"

import arrowIcon from "#/assets/arrow-down-left.svg"
import { selectIsOnEthereumChain, useDappSelector } from "#/redux-state"
import TransactionProgressLoader from "#/shared/components/TransactionProgressLoader"
import { SDK_NETWORK } from "#/shared/constants"

import SwitchChainButton from "./SwitchChainButton"

export default function ReturnAssetButton({
  onClick,
  isDisabled,
  isProcessing = false,
  content = "Withdraw",
}: {
  onClick: () => void
  isDisabled?: boolean
  isProcessing?: boolean
  content?: string
}) {
  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)

  const buttonProps = {
    variant: "unstyled",
    borderBottomWidth: isProcessing ? "0" : "2px",
    borderRadius: 0,
    borderColor: "primary.black.100",
    transitionDuration: "50ms",
    _hover: {
      color: isProcessing ? "primary.black.100" : "primary.red.100",
      borderColor: "primary.red.100",
    },
    role: "group",
    fontWeight: 500,
    fontFamily: "riforma.medium",
    h: "auto",
  }

  if (!hasCorrectChain)
    return (
      <SwitchChainButton
        label={content.toLowerCase()}
        chainId={CHAIN_ID[SDK_NETWORK]}
        fontSize="14px"
        lineHeight="20px"
        {...buttonProps}
      />
    )

  return (
    <Button
      onClick={onClick}
      isDisabled={isDisabled}
      pointerEvents={isProcessing ? "none" : "auto"}
      {...buttonProps}
    >
      <Flex gap={2}>
        {isProcessing ? (
          <TransactionProgressLoader
            text="Processing..."
            color="primary.black.70"
            size="16px"
            gap="8px"
            textVariant="bodyLarge"
          />
        ) : (
          <>
            <Text
              fontSize="20px"
              lineHeight="32px"
              fontWeight={500}
              fontFamily="riforma.medium"
            >
              {content}
            </Text>
            <Image
              src={arrowIcon}
              _groupHover={{
                filter:
                  "invert(12%) sepia(100%) saturate(5109%) hue-rotate(336deg) brightness(105%) contrast(109%)",
              }}
            />
          </>
        )}
      </Flex>
    </Button>
  )
}
